import { render } from "./LoanList.vue?vue&type=template&id=324c12f7"
import script from "./LoanList.vue?vue&type=script&lang=js"
export * from "./LoanList.vue?vue&type=script&lang=js"

import "./LoanList.vue?vue&type=style&index=0&id=324c12f7&lang=scss"

import exportComponent from "C:\\flexites\\1lombard\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__